import { render, staticRenderFns } from "./login.vue?vue&type=template&id=31c54c49&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=31c54c49&prod&lang=scss"
import style1 from "./login.vue?vue&type=style&index=1&id=31c54c49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c54c49",
  null
  
)

export default component.exports